import { render, staticRenderFns } from "./SendMealNotice.vue?vue&type=template&id=12eb4ef2"
import script from "./SendMealNotice.vue?vue&type=script&lang=js"
export * from "./SendMealNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports